import { DATE_FORMAT_YMD_DOTTED } from '@/constants/date-format';
import dayjs from 'dayjs';
import type { TFunction } from 'i18next';

const WEEKDAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;

export const formatValidDateString = (dateStr?: string | Date, formatStr: string = DATE_FORMAT_YMD_DOTTED): string | undefined => {
    if (!dateStr) {
        return undefined;
    }

    const parsedDate = dayjs(dateStr);

    if (!parsedDate.isValid()) {
        return undefined;
    }

    return parsedDate.format(formatStr);
};

export const formatKoreanDate = (dateString: string, t: TFunction): string => {
    if (!dateString) return '';

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return '';

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${year}.${month}.${day}`;
};

export const formatKoreanDateTTS = (start: string, end: string, t: TFunction<'translation', undefined>): string => {
    if (!start) return '';

    const dateStart = new Date(start);
    const dateEnd = new Date(end);

    if (isNaN(dateStart.getTime())) return '';

    const monthStart = String(dateStart.getMonth() + 1).padStart(2, '0');
    const dayStart = String(dateStart.getDate()).padStart(2, '0');
    const yearStart = String(dateStart.getFullYear());

    if (!end) {
        return t('common.tts.ongoing_from_date', { month: monthStart, day: dayStart, year: yearStart });
    }

    const monthEnd = String(dateEnd.getMonth() + 1).padStart(2, '0');
    const dayEnd = String(dateEnd.getDate()).padStart(2, '0');
    const yearEnd = String(dateEnd.getFullYear());

    return t('common.tts.day', { month: monthStart, day: dayStart, year: yearStart, month2: monthEnd, day2: dayEnd, year2: yearEnd });
};

export const formatListTypeDateRange = (begin: string, end: string, t: TFunction): string => {
    if (!end) {
        return `${formatKoreanDate(begin, t)} ~ ${t('common.date_always')}`;
    }

    return `${formatKoreanDate(begin, t)} ~ ${formatKoreanDate(end, t)}`;
};
